import z from "zod";
import type { Context } from "hono";
import { ImagineUIMessage } from "..";

export const getProjectMessagesQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(20),
  offset: z.coerce.number().int().min(0).default(0),
  afterMessageId: z.string().optional(),
});

export type GetProjectMessagesQuery = z.infer<
  typeof getProjectMessagesQuerySchema
>;

export type GetProjectMessagesResponseBody = {
  projectId: string;
  messages: ImagineUIMessage[];
  pagination: {
    total: number;
    count: number;
    limit: number;
    offset: number;
    hasMore: boolean;
    nextOffset: number | null;
    afterMessageId: string | null;
  };
};

export type GetProjectMessagesHandlerReturnType = Promise<
  ReturnType<
    typeof Context.prototype.json<
      | GetProjectMessagesResponseBody
      | { error: string }
      | { errors: z.ZodIssue[] }
      | string
    >
  >
>;
